import { render } from "./adminMenu.vue?vue&type=template&id=232f6d68&scoped=true"
import script from "./adminMenu.vue?vue&type=script&lang=js"
export * from "./adminMenu.vue?vue&type=script&lang=js"

import "./adminMenu.vue?vue&type=style&index=0&id=232f6d68&lang=scss&scoped=true"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-232f6d68"]])

export default __exports__